import {useState} from "react";

export const useHalfCalculatorData = () => {
    const [halfCalculatorOpen, setHalfCalculatorOpen] = useState({
        open: false,
        prices: null
    })
    const handleHalfCalculator = (newValue) => {
        setHalfCalculatorOpen({...newValue})
    }

    return {
        halfCalculatorOpen,
        handleHalfCalculator,
    }
}